export default {
  data() {
    return {
      occurrenceFeedChannelName: null,
      occurrenceFeedListener: null,
      occurrenceStepListener: null,
      occurrenceFeedPending: [],
    }
  },

  computed: {
    occurrenceFeedCount() {
      return this.occurrenceFeedPending.length
    },
  },

  methods: {
    watchOccurrenceFeed() {
      if (typeof window.Echo === 'undefined') return
      if (this.occurrenceFeedListener) return

      const node = this.$store.state.selected_node
      if (!node || !node.id) return

      this.occurrenceFeedChannelName = `node.${node.id}`
      this.occurrenceFeedListener = payload => this.onOccurrenceCreated(payload)
      this.occurrenceStepListener = payload => this.onOccurrenceStepChanged(payload)

      window.Echo.private(this.occurrenceFeedChannelName)
        .listen('.OccurrenceCreated', this.occurrenceFeedListener)
        .listen('.OccurrenceStepChanged', this.occurrenceStepListener)
    },

    unwatchOccurrenceFeed() {
      if (typeof window.Echo === 'undefined' || !this.occurrenceFeedChannelName) return

      // stopListening e nao leave(): o canal do no e compartilhado com as
      // posicoes, as solicitacoes de equipe e os eventos de despacho.
      window.Echo.private(this.occurrenceFeedChannelName)
        .stopListening('.OccurrenceCreated', this.occurrenceFeedListener)
        .stopListening('.OccurrenceStepChanged', this.occurrenceStepListener)

      this.occurrenceFeedChannelName = null
      this.occurrenceFeedListener = null
      this.occurrenceStepListener = null
    },

    onOccurrenceStepChanged(payload) {
      if (!payload || !payload.id) return

      if (typeof this.applyOccurrenceFeed === 'function') this.applyOccurrenceFeed()
    },

    onOccurrenceCreated(payload) {
      if (!payload || !payload.id) return
      if (this.occurrenceFeedPending.some(o => o.id === payload.id)) return

      this.occurrenceFeedPending.push(payload)

      if (typeof this.applyOccurrenceFeed === 'function') this.applyOccurrenceFeed()
    },

    clearOccurrenceFeed() {
      this.occurrenceFeedPending = []
    },
  },

  beforeDestroy() {
    this.unwatchOccurrenceFeed()
  },
}
